module.exports = __webpack_public_path__ + "img/lightbulb.ab0a6a72.png";